module.exports = __webpack_public_path__ + "media/images/emblems/BrioneSopraMinusio-coat_of_arms-a226a02a15662515966d1411dccbb545.svg";